export default __webpack_public_path__ + "static/media/weapons.77588245.jpg";